import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Form, Overlay, Popover } from 'react-bootstrap';
import styled from 'styled-components';

const TextAreaField = styled(Overlay)`
    height: 32px;
    width: 200px;
    &:hover {
        cursor: pointer;
    }
`;

// Validation schema
const formSchema = Yup.object().shape({
  message: Yup.string().required('Required'),
});

const FormPopover = ({
  show,
  target,
  onHide,
  title = "Form",
  onSubmit,
  submitButtonText = "Submit",
  submitButtonClass = "btn btn-primary",
  name,
  fieldName = "message",
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    resolver: yupResolver(formSchema),
    defaultValues: {
      [fieldName]: '',
    },
  });

  // Handle form submission
  const handleFormSubmit = async (values) => {
    try {
      await onSubmit({...values,status:name});
      // Reset form on successful submission
      reset({
        [fieldName]: "",
      });
      onHide(); // Close the popover
    } catch (error) {
      console.error('Form submission failed:', error);
    }
  };

  // Handle form close - reset form
  const handleFormClose = () => {
    reset();
  };

  // Handle popover hide
  const handleHide = () => {
    handleFormClose();
    onHide();
  };

  return (
    <TextAreaField 
      rootClose={true}
      show={show}
      target={target}
      placement="left"
      onHide={handleHide}
    >
      <Popover id="popover-contained">
        <Popover.Header as="h3">{title}</Popover.Header>
        <Popover.Body className="text-end">
          <Form onSubmit={handleSubmit(handleFormSubmit)}>
            <Form.Group>
              <Form.Control
                type="text"
                as="textarea"
                {...register(fieldName)}
                rows={4}
                className="b-r-10 text-uppercase"
                isInvalid={!!errors[fieldName]}
                style={{ resize: 'none', width: '400px' }}
                // placeholder={placeholder}
              />
              <Form.Control.Feedback type="invalid">
                {errors[fieldName]?.message}
              </Form.Control.Feedback>
            </Form.Group>
            
            <button 
              type="submit" 
              disabled={isSubmitting}
              className={submitButtonClass}
              data-bs-display="static" 
              aria-expanded="false"
            >
              {isSubmitting ? 'Processing...' : submitButtonText}
            </button>
          </Form>
        </Popover.Body>
      </Popover>
    </TextAreaField>
  );
};

export default FormPopover;